import { NavLink } from "navigation/styled";
import * as React from "react";

interface LinkWithMessageBubbleProps {
    href?: string;
    openCookieConsentBanner?: () => void;
}

const LinkWithMessageBubble: React.FC<LinkWithMessageBubbleProps> = ({ href, openCookieConsentBanner }) => {
    return (
        <NavLink href={href} rel="noreferrer" onClick={openCookieConsentBanner} style={{ alignItems: "center" }}>
            <i className="ci-message_round" style={{ marginRight: '8px', fontSize: "24px" }} />
            {FRENDS.Localizations.Help}
        </NavLink>
    )
};

export default LinkWithMessageBubble;
